import ImageButton from './_image-button.js'
import AbsolutePane from './_absolute-pane.js'

export default {
  name: 'SwiperNavigationButton',
  values: {
    button: {
      configSet: ImageButton,
      configValues: {
        innerContainer: {
          style: {
            justifyContent: 'center',
          },
        },
        buttonIcon: {
          style: {
            width: '16px',
            height: '16px',
          },
        },
      },
    },
    container: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          zIndex: 1,
          width: '40px',
          height: '100%',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
